import {AxiosResponse} from 'axios';
import {EfeResponse, UserRegistrationRequest, UserRegistrationResponse} from 'commons/models';
import EfeApi from 'services/api/Api';

async function userRegistration(
    request: UserRegistrationRequest
): Promise<EfeResponse<UserRegistrationResponse>> {
    try {
        return await EfeApi.Users.post<UserRegistrationResponse>(
            '/api/v1/users/registration',
            request
        ).then((res: AxiosResponse<UserRegistrationResponse>) => {
            return Promise.resolve({
                data: res.data,
                status: 'Success',
                success: true,
                code: res.status,
                message: 'Ok',
            });
        });
    } catch (error) {
        return Promise.reject(error);
    }
}

export default {
    userRegistration,
};
